import { defer, LoaderFunctionArgs } from 'react-router-dom';
import { IDexBigTrade } from '@kattana-io/common';
import { KattanaAPI } from '../../store/createStore';

export type bigTradesPageLoaderDataType = IDexBigTrade[] | null;

const bigTradesLoader = async ({ request }: LoaderFunctionArgs) => {
  const url = new URL(request.url);
  const chain = url.searchParams.get('chain') || '';

  const trades = KattanaAPI.bigTrades('10000', '100', chain);

  return defer({ trades });
};

export default bigTradesLoader;
